import * as React from "react";
import classes from "./IconAddTaskMobile.module.scss";
const IconAddTaskMobile = ({ onClick }) => (
  <button
    type="button"
    className={classes.addTaskMobile}
    onClick={onClick}
    aria-label="Add new task"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
      <path
        fill="#FFF"
        d="M7.368 12V7.344H12V4.632H7.368V0H4.656v4.632H0v2.712h4.656V12z"
      ></path>
    </svg>
  </button>
);

export default IconAddTaskMobile;
